import { useState } from 'react';
import { SidebarMenuItem, SidebarMenuButton } from '@/app/_components/ui/sidebar';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@/app/_components/ui/collapsible';
import {
  Sparkles,
  MessageSquare,
  Image,
  Video,
  Mic,
  Volume2,
  FileText,
  Shield,
  ChevronRight,
} from 'lucide-react';
import { SidebarMenuSubList } from './sidebar-menu-sub-list';

const studioItems = [
  { title: 'Chat', href: '/dashboard/studio/chat', icon: MessageSquare },
  {
    title: 'Image Generation',
    href: '/dashboard/studio/image-generation',
    icon: Image,
  },
  {
    title: 'Video Generation',
    href: '/dashboard/studio/video-generation',
    icon: Video,
  },
  {
    title: 'Audio Transcription',
    href: '/dashboard/studio/audio-transcription',
    icon: Mic,
  },
  {
    title: 'Text to Speech',
    href: '/dashboard/studio/text-to-speech',
    icon: Volume2,
  },
  { title: 'Embeddings', href: '/dashboard/studio/embeddings', icon: FileText },
  { title: 'Moderation', href: '/dashboard/studio/moderation', icon: Shield },
];

interface StudioMenuCollapsibleProps {
  isCollapsed: boolean;
  pathname: string;
  isMobile: boolean;
  openMobile: boolean;
  setOpenMobile: (open: boolean) => void;
}

export function StudioMenuCollapsible({
  isCollapsed,
  pathname,
  isMobile,
  openMobile,
  setOpenMobile,
}: StudioMenuCollapsibleProps) {
  const [studioOpen, setStudioOpen] = useState(true);
  const isStudioActive = pathname?.startsWith('/dashboard/studio') ?? false;

  return (
    <Collapsible
      open={studioOpen}
      onOpenChange={setStudioOpen}
      className="group/collapsible"
    >
      <SidebarMenuItem>
        <CollapsibleTrigger asChild>
          <SidebarMenuButton
            isActive={isStudioActive}
            tooltip="Studio"
            className="hover:cursor-pointer px-5"
          >
            <Sparkles />
            {!isCollapsed && <span>Studio</span>}
            {!isCollapsed && (
              <ChevronRight className="ml-auto transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
            )}
          </SidebarMenuButton>
        </CollapsibleTrigger>
        {!isCollapsed && (
          <CollapsibleContent>
            <SidebarMenuSubList
              items={studioItems}
              pathname={pathname}
              isMobile={isMobile}
              openMobile={openMobile}
              setOpenMobile={setOpenMobile}
            />
          </CollapsibleContent>
        )}
      </SidebarMenuItem>
    </Collapsible>
  );
}
